/**
 * Banda de legenda, PERMANENTA in cadrul aplicatiei.
 *
 * In Excel legenda era o foaie separata pe care nimeni nu o deschidea. Aici sta mereu sub bara de
 * sus: ordinea din banda e ordinea in care `Space` cicleaza starea, iar litera din banda e
 * scurtatura de tastatura. Deci legenda nu explica doar culorile — preda interactiunea.
 */

import { STARI, type CodStare } from '../lib/stari.ts';
import { StatusToken } from './StatusToken.tsx';

export interface PropsLegend {
  /** Daca e interactiva, fiecare stare devine comutator de filtru. */
  interactiv?: boolean;
  active?: readonly CodStare[];
  onToggle?: (cod: CodStare) => void;
  className?: string;
}

export function Legend({ interactiv = false, active, onToggle, className }: PropsLegend) {
  const filtrate = active && active.length > 0;

  return (
    <div
      className={`flex flex-wrap items-center gap-x-3 gap-y-1 ${className ?? ''}`}
      role={interactiv ? 'group' : undefined}
      aria-label="Legendă stări de plată"
    >
      <span className="text-11 text-ink-3">Stări:</span>

      {STARI.map((s) => {
        const activ = !filtrate || active?.includes(s.cod) === true;
        const eticheta = `${s.eticheta} — ${s.descriere}. Tastă ${s.litera} sau ${s.alias}.`;

        if (!interactiv) {
          return (
            <span key={s.cod} className="inline-flex items-center gap-1" title={eticheta}>
              <StatusToken stare={s.cod} varianta="complet" cuBara={false} />
              <span className="num text-11 text-ink-3" aria-hidden="true">
                {s.litera}
              </span>
            </span>
          );
        }

        return (
          <button
            key={s.cod}
            type="button"
            className="hit-24 inline-flex items-center gap-1"
            aria-pressed={activ}
            title={eticheta}
            onClick={() => onToggle?.(s.cod)}
            style={activ ? undefined : { opacity: 0.45 }}
          >
            <StatusToken stare={s.cod} varianta="complet" cuBara={false} />
            <span className="num text-11 text-ink-3" aria-hidden="true">
              {s.litera}
            </span>
          </button>
        );
      })}

      <span className="text-11 text-ink-3">
        Culoarea nu este niciodată singurul semn: glif, etichetă, pastilă și bară.
      </span>
    </div>
  );
}
